import svg1 from '../../images/svg-1.svg'
import svg2 from '../../images/svg-2.svg'
import svg3 from '../../images/svg-3.svg'
import svg4 from '../../images/svg-4.svg'
import svg5 from '../../images/svg-5.svg'
import svg6 from '../../images/svg-6.svg'
import svg11 from '../../images/svg-11.svg'
import logoNameColor from '../../images/logoNameColor.png'

export const homeObjOne = {
    id:'sobre',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine:'SOBRE',
    headline: 'Assessoria Contábil',
    description: 'Assessoria contábil de forma diferenciada, auxiliando nas necessidades da sua empresa com uma relação consistente e de longo prazo para que seu negócio esteja sempre em crescimento contínuo.',
    buttonLabel:'Fale Conosco',
    imgStart: true,
    img: logoNameColor,
    alt: 'Imagem assessoria contabil',
    dark: true,
    primary: true,
    darkText: true
}

export const homeObjTwo = {
    id:'conheca',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine:'CONHEÇA',
    headline: 'Saiba Mais!',
    description: 'A assessoria é contratada quando a organização precisa de um diagnóstico completo para corrigir problemas financeiros e processos internos. O serviço também é uma alternativa para empresas que desejam estar alinhadas às tendências do segmento, criar mecanismos que se diferenciem da concorrência e beneficiar clientes com uma visão imparcial do seu negócio.',
    buttonLabel:'Fale Conosco',
    imgStart: false,
    img: svg3,
    alt: 'Imagem assessoria contabil',
    dark: true,
    primary: true,
    darkText: false
}

export const homeObjThree = {
  id: "missao",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Nossa Missão",
  headline: "Benefícios da Assessoria Contábil",
  description: "Assertividade na escolha do melhor regime tributário, gerando significativa redução em despesas fiscais e previdenciárias. A gerência das despesas e custos permite uma análise minuciosa sobre o andamento da empresa, as diversas análises contribuem para uma melhor tomada de decisões e mitiga gastos.",
  buttonLabel: "Fale Conosco",
  imgStart: true,
  img: svg4,
  alt: "Imagem assessoria contabil",
  dark: true,
  primary: true,
  darkText: true,
}

export const homeObjFour = {
  id: "local",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "localização",
  headline: "Nosso endereço",
  description: "",
  buttonLabel: "Fale Conosco",
  imgStart: true,
  img: svg11,
  alt: "Imagem assessoria contabil",
  dark: true,
  primary: true,
  darkText: true,
}

export const homeObjFive = {
  id: "contact",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "contato",
  headline: "Fale conosco",
  description: "",
  buttonLabel: "Fale Conosco",
  imgStart: true,
  img: svg6,
  alt: "Imagem contato",
  dark: true,
  primary: true,
  darkText: true,
}